import { GraphQLResult } from "@aws-amplify/api-graphql";
import AWSAppSyncRealTimeProvider from "@aws-amplify/api-graphql";
import { graphqlOperation } from "aws-amplify";
import { API } from "aws-amplify";
import { DeepPartial } from "src/types/utils";
import { Observable } from "zen-observable-ts";

import { Subscription } from "../generated/graphql";
import { TypedDocumentString } from "../generated/graphql";

type SubscriptionResult<T> = {
    provider: typeof AWSAppSyncRealTimeProvider;
    value: GraphQLResult<T>;
    options: {
        authMode: "AMAZON_COGNITO_USER_POOLS" | "API_KEY";
    };
};

export const graphqlSubscribe = <TResult extends DeepPartial<Subscription>, TVariables>(
    subscription: TypedDocumentString<TResult, TVariables>,
    variables?: TVariables extends Record<string, unknown> ? TVariables : never,
    options?: {
        authMode: "AMAZON_COGNITO_USER_POOLS" | "API_KEY";
    }
): Observable<SubscriptionResult<TResult>> => {
    if (options?.authMode) {
        return API.graphql({
            authMode: options.authMode,
            query: subscription.toString(),
            variables,
        }) as Observable<SubscriptionResult<TResult>>;
    }

    return API.graphql(graphqlOperation(subscription.toString(), variables)) as Observable<SubscriptionResult<TResult>>;
};
